import { h, Component } from 'preact';
import { Form, validateField, Validators } from '../utils/form-helpers';
import FieldWrapper from './generics/FieldWrapper';
import modalContent from '../constants/modalContent';
import SignInWith from './SignInWith';
import hrefConfig from '../../config/hrefConfig';
import ButtonWrapper from './generics/ButtonWrapper';
import AlertMessage from './generics/AlertMessage';

const FIRST_NAME_FIELD = 'firstName';
const LAST_NAME_FIELD = 'lastName';
const EMAIL_FIELD = 'email';
const EMAIL_CONFIRMATION_FIELD = 'emailConfirmation';
const ACCEPT_FIELD = 'accept';

export default class SignUpContent extends Component {
  constructor () {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.validateEmailConfirmation = this.validateEmailConfirmation.bind(this);

    this.state = {
      isLoading: false,
      error: '',
      form: new Form({
        [FIRST_NAME_FIELD]: {
          value: '',
          validators: [Validators.required()],
        },
        [LAST_NAME_FIELD]: {
          value: '',
          validators: [Validators.required()],
        },
        [EMAIL_FIELD]: {
          value: '',
          validators: [Validators.required(), Validators.email()],
        },
        [EMAIL_CONFIRMATION_FIELD]: {
          value: '',
          validators: [Validators.isEqual(this.validateEmailConfirmation)],
        },
        [ACCEPT_FIELD]: {
          value: '',
          multiple: true,
          validators: [Validators.minLength(1)],
        },
      }),
    };
  }

  componentDidMount () {
    const { form } = this.state;
    form.clearValues(this);
  }

  onSubmit () {
    const { form } = this.state;
    const { session, mixpanelTracker } = this.props;
    const { pub } = window.reservamosPubSub;

    const newUserInfo = {
      firstName: form.getValue(FIRST_NAME_FIELD),
      lastName: form.getValue(LAST_NAME_FIELD),
      email: form.getValue(EMAIL_FIELD),
      emailConfirmation: form.getValue(EMAIL_CONFIRMATION_FIELD),
    };

    this.setState({ isLoading: true, error: '' });

    session
      .signUp(newUserInfo)
      .then((user) => {
        this.setState({ error: '' });
        mixpanelTracker.trackSignUp({
          'Siempre Plus Card': user.sp_card,
          'Email': newUserInfo.email,
          'Name': `${newUserInfo.firstName} ${newUserInfo.lastName}`,
          'Type': 'Siempre Plus Card',
        });

        pub('siempreplus', {
          user,
          loading: false,
          error: false,
        });
        this.setState({ isLoading: false });
      })
      .catch(({ response }) => {
        this.setState({ isLoading: false });
        response
          .json()
          .then(({ errors: [error] }) => {
            pub('siempreplus', {
              user: null,
              loading: false,
              error,
            });
            this.setState({ error: error.message });
          })
          .catch((error) => {
            console.error(error);
            pub('siempreplus', {
              user: null,
              loading: false,
              error,
            });
            this.setState({ error: 'Un error inesperado ha ocurrido' });
          });
      });
  }

  validateEmailConfirmation (value) {
    const { form } = this.state;
    return form && form.getValue(EMAIL_FIELD) === value;
  }

  render ({ onChangeContent, mixpanelTracker }) {
    const { form, error, isLoading } = this.state;

    const firstNameIsInvalid = form.fieldHasErrors(FIRST_NAME_FIELD);
    const lastNameIsInvalid = form.fieldHasErrors(LAST_NAME_FIELD);
    const emailIsInvalid = form.fieldHasErrors(EMAIL_FIELD);
    const emailConfirmationIsInvalid = form.fieldHasErrors(
      EMAIL_CONFIRMATION_FIELD,
    );
    const acceptIsInvalid = form.fieldHasErrors(ACCEPT_FIELD);

    const stop = e => e.stopPropagation();

    const signInWithCallback = type => mixpanelTracker.trackSignUp({
      'Siempre Plus Card': null,
      'Email': null,
      'Name': null,
      'Type': type,
    });

    return (
      <div>
        <form onSubmit={form.onSubmit(this, this.onSubmit)} noValidate>
          <AlertMessage type="error" visible={Boolean(error)}>
            {error}
          </AlertMessage>
          <div className="form-item-wrap">
            <FieldWrapper
              hasError={firstNameIsInvalid}
              className="form-item-wrap-left"
              errorLegend="Este campo no puede estar vacío"
            >
              <input
                name={FIRST_NAME_FIELD}
                className="invalid"
                type="text"
                placeholder="Nombre"
                onInput={validateField(this, form)}
              />
            </FieldWrapper>
            <FieldWrapper
              hasError={lastNameIsInvalid}
              className="form-item-wrap-right"
              errorLegend="Este campo no puede estar vacío"
            >
              <input
                name={LAST_NAME_FIELD}
                className="invalid"
                type="text"
                placeholder="Apellidos"
                onInput={validateField(this, form)}
              />
            </FieldWrapper>
          </div>
          <FieldWrapper
            hasError={emailIsInvalid}
            className="form-item"
            errorLegend="Por favor escriba un correo electrónico valido"
          >
            <input
              name={EMAIL_FIELD}
              className="invalid"
              type="email"
              placeholder="Correo electrónico"
              onInput={validateField(this, form)}
            />
          </FieldWrapper>
          <FieldWrapper
            hasError={emailConfirmationIsInvalid}
            className="form-item"
            errorLegend="Su correo electrónico no coincide"
          >
            <input
              name={EMAIL_CONFIRMATION_FIELD}
              className="invalid"
              type="email"
              placeholder="Confirmar correo electrónico"
              onInput={validateField(this, form)}
            />
          </FieldWrapper>
          <FieldWrapper
            hasError={acceptIsInvalid}
            className="form-item"
            errorLegend="Debe aceptar los términos y condiciones"
          >
            <label className="form-inline-checkbox">
              <div className="checkboxes-check">
                <input
                  type="checkbox"
                  name={ACCEPT_FIELD}
                  value="ok"
                  onInput={validateField(this, form)}
                />
                <span />
              </div>
              <p className="w-modal-copy">
                He leído y acepto el
                <a
                  href={hrefConfig.noticeOfPrivacy}
                  onClick={stop}
                  target="_blank"
                >
                  <span>Aviso de Privacidad</span>
                </a>
                y los
                <a
                  href={hrefConfig.termsAndConditions}
                  onClick={stop}
                  target="_blank"
                >
                  <span>Términos y Condiciones</span>
                </a>
              </p>
            </label>
          </FieldWrapper>
          <div className="form-item">
            <ButtonWrapper
              className="w-modal-button"
              type="submit"
              isLoading={isLoading}
            >
              Regístrate
            </ButtonWrapper>
          </div>
        </form>
        <SignInWith onSelect={signInWithCallback} />
        <div>
          <p className="w-modal-copy account-link">
            {/* eslint-disable-next-line */}
            <a
              className="w-modal-link"
              onClick={() => onChangeContent(modalContent.SIGN_IN)}
            >
              {'¿Ya tienes cuenta? '}
              <span>Iniciar sesión</span>
            </a>
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/SignUpContent.js